import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ComplianceCard, MessageBox } from 'src/components/Compliance';
import { ROUTES } from 'src/constants/routes';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';
import Logomark from '../../assets/images/Logomark.png';
import { cardsData } from './ComplianceCards.data';
import {
  CardsContainerStyled,
  HeaderStyled,
  HeroStyled,
} from './styles/ComplianceWelcomeNew.styles';

const ComplianceWelcome: React.FC = () => {
  const getUrlWithQueryParams = useLocationSearch();
  const history = useNavigate();

  const nextPage = (key: string) => {
    const url =
      key === '1' ? ROUTES.START_APPLICATION_PATH : ROUTES.COMPLIANCE_PATH;
    history(getUrlWithQueryParams(url), { state: { detail: 'compliance' } });
  };

  return (
    <HeaderStyled>
      <HeroStyled container>
        <Grid item>
          <Typography variant="h3">Get covered by TheGuarantors</Typography>
        </Grid>
        <Grid item>
          <Typography
            variant="body1"
            textAlign="center"
            letterSpacing="0.3px"
            maxWidth={{ sm: '434px', md: '610px' }}
            lineHeight={{ xs: '24px', md: '26px' }}
            sx={{
              textAlign: { xs: 'left', sm: 'center' },
            }}
          >
            We partner with your building to provide renters insurance or verify your existing insurance policy. Select whether you need to purchase or verify a policy.
          </Typography>
        </Grid>
      </HeroStyled>

      <CardsContainerStyled container>
        {cardsData.map((card, index) => {
          const { key, title, mainText, linkText, carousel, bgColor, img } = card;
          return (
            <ComplianceCard
              v2
              key={key}
              bgColor={bgColor}
              onClick={() => nextPage(key)}
              title={title}
              mainText={mainText}
              carousel={carousel}
              linkText={linkText}
              img={img}
              index={index}
              fullWidth
              blackButton
              center
              ff_ren1520_compliancewelcome_newdesign
            />
          );
        })}
        <MessageBox
          image={Logomark}
          title="Still have questions?"
          subtitle="Learn more"
          welcomePage
          fullWidth
          maxWidth='870px'
        />
      </CardsContainerStyled>
    </HeaderStyled>
  );
};

export default ComplianceWelcome;
